import type { TFunction } from "i18next";

import createDockPageRegistry, { type DockPageMeta } from "~/components/dock/dockPageRegistry";

const createAdminPages = (
	t: TFunction<"common">,
	canManageParentCompany = false,
	canManageSecurity = false
): DockPageMeta[] => [
	{
		id: "general",
		path: "/settings/general",
		title: t("dock.pages.admin.general")
	},
	{
		id: "billing",
		path: "/settings/billing",
		title: t("dock.pages.admin.billing")
	},
	{
		id: "integrations",
		path: "/settings/integrations",
		routePattern: "integrations/*",
		title: t("nav.system.integrations.label")
	},
	{
		id: "users",
		path: "/settings/users",
		title: t("nav.system.users.label")
	},
	{
		id: "email",
		path: "/settings/email",
		title: t("dock.pages.admin.email")
	},
	{
		id: "devices",
		path: "/settings/devices",
		title: t("dock.pages.admin.devices")
	},
	{
		id: "data-management",
		path: "/settings/data-management",
		title: t("nav.system.dataManagement.label")
	},
	...(canManageSecurity
		? [
				{
					id: "security",
					path: "/settings/security",
					title: t("dock.pages.admin.security")
				}
			]
		: []),
	...(canManageParentCompany
		? [
				{
					id: "parent-company",
					path: "/settings/parent-company",
					title: t("settings.parentCompany.navLabel")
				}
			]
		: [])
];

const createAdminDockPageRegistry = (
	t: TFunction<"common">,
	canManageParentCompany = false,
	canManageSecurity = false
) => createDockPageRegistry(createAdminPages(t, canManageParentCompany, canManageSecurity), "general");

export default createAdminDockPageRegistry;
